<script lang="ts">
	import termsHtml from '$lib/legal/terms-content.html?raw';
</script>

<svelte:head>
	<title>Terms of Service - Piefect</title>
	<meta name="description" content="Terms of Service for Piefect expense sharing application." />
</svelte:head>

<div class="mx-auto max-w-4xl px-6 py-16">
	<article class="prose prose-sage max-w-none">
		{@html termsHtml}
	</article>
</div>
